export const getTransactionsInitialEndPoint =
  'Buyer/GetTransactionsInitialData';
export const getTransactionsEndPoint = 'Buyer/GetTransactions';
export const getTransactionDetailsEndPoint = 'Buyer/GetTransactionDetails';
export const getPlafondsEndPointBuyer = 'Buyer/GetPlafonds';
export const getPlafondsEndPointMerchant = 'Merchant/GetPlafond';
